import { Locale } from 'modules/i18n';

export const aapiAboutContentTranslation = {
  [Locale.en]: {
    about:
      'Advanced API is a collection of RPC methods designed to address the most popular Web3 scenarios, query archive data at near-instant speeds, and interact with multiple chains in a single request.',
    learnMore: 'Learn more',
  },
};
